export default {"src":"/_next/static/media/Arrow.8df76513.svg","height":64,"width":50,"blurWidth":0,"blurHeight":0};